import { authorizedRequestJson } from '../lib/authSession';
import { requestJson } from './apiClient';

export function createLivePhotoLink({ token, tripId, memberId, requirementUuid }) {
  return authorizedRequestJson('/live-photo-links', {
    method: 'POST',
    body: { tripId, memberId, requirementUuid },
  });
}

export function getLivePhotoLinkStatus({ sessionId }) {
  return requestJson(`/live-photo-links/${encodeURIComponent(sessionId)}`);
}

export function createLivePhotoUpload({ sessionId, fileName, contentType }) {
  return requestJson(`/live-photo-links/${encodeURIComponent(sessionId)}/upload`, {
    method: 'POST',
    body: { fileName, contentType },
  });
}

export function completeLivePhotoUpload({ sessionId, objectKey, fileName, contentType }) {
  return requestJson(`/live-photo-links/${encodeURIComponent(sessionId)}/complete-upload`, {
    method: 'POST',
    body: { objectKey, fileName, contentType },
  });
}

export function finalizeLivePhotoLink({ token, sessionId }) {
  return authorizedRequestJson(`/live-photo-links/${encodeURIComponent(sessionId)}/finalize`, {
    method: 'POST',
  });
}
